// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AboutClinic_clinic__2ZCx- {
  padding: 100px 0;
}
.AboutClinic_clinic__2ZCx- .AboutClinic_container__x0yHI {
  max-width: 1100px;
  margin: 0 auto;
  padding: 0 20px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.AboutClinic_clinic__2ZCx- h2 {
  font-size: 2rem;
  color: #14213d;
  font-weight: 700;
  text-transform: uppercase;
  margin-bottom: 25px;
  text-align: left;
}
.AboutClinic_clinic__2ZCx- p {
  font-size: 1rem;
  color: #444;
  line-height: 1.8;
  text-align: left;
}
@media (max-width: 768px) {
  .AboutClinic_clinic__2ZCx- .AboutClinic_container__x0yHI {
    align-items: center;
    text-align: center;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/styleAboutUs/AboutClinic.module.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;AACF;AACE;EACE,iBAAA;EACA,cAAA;EACA,eAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;AACJ;AAEE;EACE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;AAAJ;AAGE;EACE,eAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;AADJ;AAIE;EACE;IACE,mBAAA;IACA,kBAAA;EAFJ;AACF","sourcesContent":[".clinic {\r\n  padding: 100px 0;\r\n\r\n  .container {\r\n    max-width: 1100px;\r\n    margin: 0 auto;\r\n    padding: 0 20px;\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n  }\r\n\r\n  h2 {\r\n    font-size: 2rem;\r\n    color: #14213d;\r\n    font-weight: 700;\r\n    text-transform: uppercase;\r\n    margin-bottom: 25px;\r\n    text-align: left;\r\n  }\r\n\r\n  p {\r\n    font-size: 1rem;\r\n    color: #444;\r\n    line-height: 1.8;\r\n    text-align: left;\r\n  }\r\n\r\n  @media (max-width: 768px) {\r\n    .container {\r\n      align-items: center;\r\n      text-align: center;\r\n    }\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"clinic": `AboutClinic_clinic__2ZCx-`,
	"container": `AboutClinic_container__x0yHI`
};
export default ___CSS_LOADER_EXPORT___;
